<div class="centered-column">
  <div class="top-cbre-section">
    <div class="cbre-logo-wrapper">
      <img src="assets/images/cbre-logo.png" alt="CBRE Logo"/>
    </div>
    <p class="cbre-tagline">The Worldwide Leader in Commercial Real Estate Services</p>
  </div>
  <div class="centered-info-box">
    <div class="finishline-logo">
      <img src="assets/images/finishline-login-logo.png" alt="Finishline App Logo" />
    </div>
    <div class="finishline-tagline">Get To The Finishline Faster</div>
    <div class="info-box-content">
      <h2 class="loading">Authenticating...</h2>
    </div>
  </div>
</div>